/**
 * User-facing copy for the Android app page (/app).
 *
 * Kept in a constants file per the repo convention (no hardcoded UI strings in components).
 * Every claim is what the app actually does, taken from the app's own "What's in here" list
 * (src/components/mobile/mobileNotes.js) and verified on a Pixel. Do not add a feature the app
 * does not have; when the app changes, change this in the same commit.
 */

export const APP_EYEBROW = "Free on iPhone and Android";

export const APP_TITLE = "CherryClipz in your pocket.";

export const APP_SUBTITLE =
  "Pick a video on your phone. It becomes clips — one per sentence, or by time. Keep the good ones, trim, and share the cut. No account and no signal needed.";

// Both apps are in the stores (Google Play 2026-09-28, App Store since): the page sends people
// there. The old sideload APK, the "email me the link" fallback and the three install taps are gone.
export const APP_STORE_FINE = "Free · iPhone and Android · scan the code with your phone's camera, or tap the button for your phone.";
export const APP_QR_LABEL = "Scan to get the app";

export const APP_DOES_EYEBROW = "What it does";

export const APP_DOES_HEADING = "Your video, as clips.";

export const APP_DOES = [
  "Pick one or several videos from the phone.",
  "Cut by what was said: the phone listens and makes one clip per sentence. Nothing is uploaded; it works in airplane mode.",
  "Search the words. Type one and only the moments someone said it are left.",
  "Or cut into 2, 5 or 10-second clips instantly, with no listening at all.",
  "Every clip gets a picture from your own video, made on the phone.",
  "Tap a clip to watch just that piece. Tap the circle to keep it — the number is its place in your edit.",
  "The timeline is your edit: slide clips to reorder, tap one to trim its start and end while watching, or bin it.",
  "Play runs the whole edit back to back, even across different videos.",
  "Share makes one video from your edit, cut and joined on the phone, and hands it to WhatsApp, Instagram or anything else.",
  "Your last projects stay on the phone. Open them again from Projects.",
];

export const APP_AI_EYEBROW = "With your CherryClipz account";

export const APP_AI_HEADING = "Same account, same library.";

export const APP_AI = [
  "Send a video to CherryClipz for the full transcript: far more accurate words, who is speaking, and the mood of each line — the same spreadsheet the website makes, in your library.",
  "Open anything already in your library — sent from the website, the Premiere panel or the phone — without uploading it again.",
  "Sign in with the same email code as the website. Your plan's hours apply. The app itself never charges anything.",
];

export const APP_KNOW_HEADING = "Good to know";

export const APP_KNOW = [
  "On-phone listening understands English and gives no punctuation or speaker names. Sending to CherryClipz is the accurate option.",
  "Nothing leaves the phone unless you choose to send it.",
];

export const APP_HELP_PREFIX = "Something off? Tell us:";
